import { render, staticRenderFns } from "./SharingOptions.vue?vue&type=template&id=07103d46&"
import script from "./SharingOptions.vue?vue&type=script&lang=ts&"
export * from "./SharingOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports